import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { childrenPropType, TSS_DARK_BLUE } from 'tss-core-lib-common';

var styles = void 0;

var BlockSection = function BlockSection(_ref) {
  var children = _ref.children,
      borderTop = _ref.borderTop;
  return React.createElement(
    'div',
    { className: css(styles.container, borderTop && styles.borderTop) },
    children
  );
};

BlockSection.propTypes = {
  children: childrenPropType,
  borderTop: PropTypes.bool
};

BlockSection.defaultProps = {
  children: null,
  borderTop: false
};

styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    padding: '2.3rem 2.3rem 2.5rem 2.3rem'
  },

  borderTop: {
    borderTop: '1px solid ' + TSS_DARK_BLUE(0.05)
  }
});

export default BlockSection;